import { thumbnailUrl } from "../../../../../api/src/shared/domain/video-url";
import { useAudioContext } from "../../app/contexts/audio.context";
import type { RoomResourceListItem } from "./useGetRoomResourceItemsQuery";

/** A standalone audio file curated into a room: it has no page, it plays. */
export type AudioContent = Extract<
  Extract<RoomResourceListItem, { kind: "content" }>["content"],
  { content_format: "Audio" }
>;

/**
 * Plays a room's audio content in the app's player: the sidebar on desktop,
 * the expanded mini player on mobile.
 */
export function usePlayAudioContent(): (content: AudioContent) => void {
  const audioContext = useAudioContext();
  return (content) => {
    const thumbnail = thumbnailUrl(content);
    const imageUrl = thumbnail === null ? "" : thumbnail;
    audioContext.setTracks({
      track: { kind: "file" },
      contentList: [
        {
          type: "playlist_audio_content",
          source: content,
          title: content.title,
          trackUrl: content.audio.url,
          imageUrl,
        },
      ],
      index: 0,
      autoplay: true,
    });
    audioContext.setTrackTitle(content.title);
    audioContext.setTrackImageUrl(imageUrl);
    audioContext.setTrackCollectionName("");
    audioContext.setAudioPlayerPanelOpen(true);
  };
}
